import { Button, ButtonLink } from '@backstage/ui';
import { RiAddLine } from '@remixicon/react';
import styles from './GenerateKeyButton.module.css';

/**
 * The one "create a key" call-to-action, shared by the page header, the keys
 * table and the homepage budget card so copy, icon and styling stay identical.
 */
export interface GenerateKeyButtonProps {
  /** Deep-link target (e.g. `/litellm?generate=1`). Ignored when `onClick` is set. */
  to?: string;
  /** Takes precedence over `to` when both are given. */
  onClick?: () => void;
  /** Override the default `Generate New Key` copy (e.g. empty-state variants). */
  label?: string;
  size?: 'small' | 'medium';
  /** Stretch to the container width (card footers). */
  fullWidth?: boolean;
  /** A disabled `to` renders inert rather than linking. */
  disabled?: boolean;
}

export const GenerateKeyButton = ({
  to,
  onClick,
  label = 'Generate New Key',
  size,
  fullWidth = false,
  disabled = false,
}: GenerateKeyButtonProps) => {
  const common = {
    variant: 'primary' as const,
    size,
    iconStart: <RiAddLine />,
    className: fullWidth ? styles.fullWidth : undefined,
  };
  if (to && !onClick && !disabled) {
    return (
      <ButtonLink {...common} href={to}>
        {label}
      </ButtonLink>
    );
  }
  return (
    <Button {...common} onPress={onClick} isDisabled={disabled || !onClick}>
      {label}
    </Button>
  );
};
